import styled from 'styled-components'
import { Box, theme, Grid } from '@dasa-health/components-react'

export const Container = styled.div`
    width: 100vw;
    margin: 0 auto;
    padding-bottom: 32px;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        max-width: calc(100vw - 150px);
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        max-width: 54.5rem;
        padding-bottom: 64px;
    }
`

export const TopicBox = styled(Grid)`
    padding: 1rem;
    margin-top: 30px !important;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        padding: 0 1rem;
        margin-top: 50px !important;
    }
`
export const PrincipalBox = styled(Grid)`
    padding: 1rem;
    margin-top: 3.125rem !important;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
    }

    @media screen and (min-width: 30rem) {
        padding-bottom: 0;
        margin-top: 0 !important;
    }
`

export const BoxTexts = styled(Box)`
    min-width: 12.688rem !important;
    max-width: 20.625rem !important;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        max-width: 18.125rem !important;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        width: 100%;
        min-width: 29.275rem !important;
    }
`

export const Title = styled.h1`
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.995rem;
    text-align: left;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.5rem;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        font-size: 2rem;
        font-weight: 700;
        line-height: 2.5rem;
    }
`

export const SubTitle = styled.p`
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.488rem;
    text-align: left;
    padding-top: 1rem;
    color: #161616;

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        max-width: 26.875rem;
    }
`

export const Img = styled.img`
    width: 100%;
    max-width: 23.625rem;
    min-width: 8.125rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        max-width: 12.813rem;
        float: right;
    }

    @media screen and (min-width: 45rem) {
        position: relative;
        min-width: 80%;
        top: 2.375rem;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        width: 100%;
        min-width: 25rem;
    }
`

export const ButtonsBox = styled(Box)`
    width: 100%;
    display: flex;
    gap: 0.5rem;
    padding: 1rem;

    align-items: center;
    justify-content: space-between;

    a {
        flex: 1;
        display: inherit;
    }

    button {
        flex: 1;
        font-size: 0.875rem;
        height: 2rem !important;
        width: 100%;
    }

    @media screen and (min-width: 42.5rem) {
        padding: 1rem;
        max-width: 20rem;
        margin-top: -5% !important;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        button {
            min-width: 10rem;
        }
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        position: relative;
        top: -3.125rem;

        button {
            font-size: 1rem;
            height: 3rem !important;
            min-width: 12.5rem;
            width: 100%;
        }
    }
`
